import React, {PropTypes} from 'react'
import styles from './PillList.scss'

export const Pill = ({children}) => {
	return (
		<span className={styles.pill}>
			{children}
		</span>
	)
}
Pill.propTypes = {
	children: PropTypes.node,
}

export const PillList = ({children, title, noPills = ''}) => {
	return (
		<span className={styles.wrapper}>
			<span className={styles.title}>{title}:&nbsp;</span>
			{children.length ? (
				children.map((pill, i) => <Pill key={i}>{pill}</Pill>)
			) : (
				<span className={styles.noPills}>{noPills}</span>
			)}
		</span>
	)
}
PillList.propTypes = {
	children: PropTypes.arrayOf(PropTypes.node).isRequired,
	title: PropTypes.string.isRequired,
	noPills: PropTypes.node,
}

export default PillList



// WEBPACK FOOTER //
// ./elements/PillList.jsx